import { render, staticRenderFns } from "./vectorSoftware.vue?vue&type=template&id=5bf17033&scoped=true"
import script from "./vectorSoftware.vue?vue&type=script&lang=js"
export * from "./vectorSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf17033",
  null
  
)

export default component.exports